
import { ButtonFieldConfig, DynamicFormArray, FormFieldConfig } from './form.model';
import { AreaDropdown, PrimaryRoleDropdown, IsPcDropdown, IsCertJobRoleDropdown, defaultSearchContainerButtons, FieldNames, DealerNumberDropdown, westernArea, centralArea, easternArea, southernArea, EmpStatusDropdown, JobStatusDropdown, DropdownOptions } from './form-fields.model';
import { DataTableSchema, DefaultTableSchema, TableColumnSchema } from './dynamic-data-table.model';
import { FETCH_METHODS, SearchConfig } from './api.model';
import { OptionsFetchConfig } from './common.model';


const FormFieldArray: FormFieldConfig[] = [
    {...structuredClone(AreaDropdown),multiple:true, options: [{ fieldLabel: westernArea, fieldValue: westernArea }, { fieldLabel: centralArea, fieldValue: centralArea }, { fieldLabel: easternArea, fieldValue: easternArea }, { fieldLabel: southernArea, fieldValue: southernArea }]}, 
    {...structuredClone(PrimaryRoleDropdown),
        options:[{ fieldLabel: 'ALL', fieldValue: '' }, { fieldLabel: 'YES', fieldValue: 'Yes' },{ fieldLabel: 'No', fieldValue: 'No' }],
        showSelect:false,
    },{...structuredClone(IsPcDropdown),
        options:[{ fieldLabel: 'YES', fieldValue: 'Yes' }, { fieldLabel: 'No', fieldValue: 'No' }]
    },{
        ...structuredClone(IsCertJobRoleDropdown),
        options:[{ fieldLabel: 'Yes', fieldValue: 'Yes' },{ fieldLabel: 'No', fieldValue: 'No' }]
    },
    {...structuredClone(EmpStatusDropdown), defaultValue: 'Active'},
    {...structuredClone(DealerNumberDropdown)},
    {...structuredClone(JobStatusDropdown)}, 
    ];

const FormButtonArray: ButtonFieldConfig[] = structuredClone(defaultSearchContainerButtons);

export const StaffMasterTitle = "Staff Master Complete Data";

export const StaffMasterSearchConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'staffMasterSearch',
    body:{
        [FieldNames['Area']]:"",
        [FieldNames['PrimaryRole']]:"",
        [FieldNames['IsPc']]:"",
        [FieldNames['IsCertJobRole']]:"",
        [FieldNames['Dealer']]:"",
        [FieldNames['JobStatus']]: ""
    }
}

export const StaffMasterFilterSchema: DynamicFormArray = {
    FieldsArray: FormFieldArray,
    ButtonsArray: FormButtonArray,
    searchConfig: StaffMasterSearchConfig,
    autoSearchOnLoad:true
}

export const StaffMasterExportSearchConfig:SearchConfig = {
    method:FETCH_METHODS['Post'],
    path:'getSignedUrl',
    body:{
        bucketName:'',
        key: '',
        type: 'Download'
    }
}

const StaffMasterColumnSchema: Array<TableColumnSchema> = [
    { label: 'SPIN', fieldKey: 'spinId',sticky:true },
    { label: 'DEALER CODE', fieldKey: 'dealerCode',sticky:true},
    { label: 'FIRST NAME', fieldKey: 'firstName' },
    { label: 'LAST NAME', fieldKey: 'lastName' },
    { label: 'EMAIL', fieldKey: 'email', isNotCamelCase: true },
    { label: 'DEALER', fieldKey: 'dealerName' },
    { label: 'AREA', fieldKey: 'area' },
    { label: 'DISTRICT', fieldKey: 'district' },
    { label: 'JOB CODE', fieldKey: 'jobCode' },
    { label: 'JOB DESCRIPTION', fieldKey: 'jobDescription' },
    { label: 'JOB START DATE', fieldKey:'jobStartDate' },
    { label: 'JOB END DATE', fieldKey: 'jobEndDate' },
    { label: 'PRIMARY ROLE', fieldKey: 'primaryRole' },
    { label: 'EMPLOYEE STATUS', fieldKey: FieldNames['EmployeeStatus'], fieldType:'Array', options: DropdownOptions[FieldNames.EmployeeStatus] },
    { label: 'IS PC?', fieldKey: 'isPC' },
    { label: 'IS CERTIFIABLE JOB ROLE?', fieldKey: 'isCertifiableRole' },


];

export const StaffMasterDynamicOptionSchema: OptionsFetchConfig = {
    fields: [
        { name: FieldNames['DealerNumber'], keyValuePair: { fieldLabel: 'dealerCode', fieldValue: 'dealerCode' } }
    ],
    searchConfig: {
        method: FETCH_METHODS['Get'],
        path: 'dealerDropdown',
    }
}

export const StaffMasterTableSchema: DataTableSchema = {
    ...structuredClone(DefaultTableSchema),
    columnSchema: StaffMasterColumnSchema,
    exportConfig: {
        fileName: 'Staff_Master',
        exportMessage:StaffMasterTitle,
        schema: {
            spinId: "SPIN",
            dealerCode: "DEALER CODE",
            firstName:"FIRST NAME",
            lastName:"LAST NAME",
            email:"EMAIL",
            dealerName:"DEALER",
            area:"AREA",
            district:"DISTRICT",
            jobCode:"JOB CODE",
            jobDescription:"JOB DESCRIPTION",
            jobStartDate:"JOB START DATE",
            jobEndDate:"JOB END DATE",
            primaryRole:"PRIMARY ROLE",
            isPC:"IS PC?",
            isCertifiableRole:"IS CERTIFIABLE JOB ROLE?"
        },
    },
    serverSidePaginatation:true,
    breadcrums: [{ level: 1, name: StaffMasterTitle }],
}
